import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { CatalogosComponent } from "./catalogos.component";
import { DatosCatalogoComponent } from "./datos-catalogo/datos-catalogo.component";
import { ProductoComponent } from './producto/producto.component';
import { ClienteComponent } from './cliente/cliente.component';
import { ProductoCargaMasivaComponent } from './producto/producto-carga-masiva/producto-carga-masiva.component';
// import {GrupoActivosComponent} from "./cat-activos/grupo-activos/grupo-activos.component";
// import { ZonaGeograficaComponent } from './cat-geografico/zona-geografica/zona-geografica.component';



const routes: Routes = [

  {
    path: 'productos',
    component: ProductoComponent,
  },
  {
    path: 'clientes',
    component: ClienteComponent,
  },
  {
    path: 'carga-masiva-productos',
    component: ProductoCargaMasivaComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CatalogosRouting {
}
